import {Component} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';
import {CONFIG} from "../../../app/config";
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {TAction} from "../../../app/enum";

@Component({
    selector: 'page-showbook',
    templateUrl: 'showbook.html',
    providers: []
})
export class ShowbookPage {

    TAction: any = TAction;

    config: any;

    action: any;
    hotspotID: number;
    decolagemID: number;

    decolagens: any = [];

    constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController,
                public util: Util) {

        this.config = CONFIG;

        this.action = TAction[this.navParams.get('action')];

        this.hotspotID = <number>this.navParams.get('hotspotID');
        this.decolagemID = <number>this.navParams.get('decolagemID');

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Showbook', '/Showbook-lista');

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }


    itemsee() {

    }

    dismiss() {

        this.navCtrl.pop();
        this.util.statusBarColor(TStatusBar.sbStyleDefault);

    }

}



// WEBPACK FOOTER //
// ./src/pages/show/showbook/showbook.ts